"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textTruncate = exports.Table = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrapTable2Overlay = _interopRequireDefault(require("react-bootstrap-table2-overlay"));
var _reactBootstrapTable2Paginator = _interopRequireDefault(require("react-bootstrap-table2-paginator"));
var _toolkit = require("./toolkit");
var _Spinner = require("../Spinner");
var _eventBus = _interopRequireDefault(require("../eventBus"));
var _TextTruncateWrapper = _interopRequireDefault(require("./TextTruncateWrapper"));
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const textTruncate = cell => {
  return /*#__PURE__*/_react.default.createElement(_TextTruncateWrapper.default, {
    cell: cell
  });
};
exports.textTruncate = textTruncate;
class Table extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "handleRemoveRows", () => {
      let {
        dataUpdated
      } = this.state;
      let getRemovedRowList = [];
      Object.keys(this.selectedRows).forEach(key => {
        getRemovedRowList.push(this.selectedRows[key]);
      });
      this.selectedRows = {};
      this.setState({
        dataUpdated: dataUpdated.filter(val => !getRemovedRowList.includes(val)),
        selectedRowCount: 0
      });
    });
    this.state = {
      isDataFetched: props.isDataFetched || false,
      loading: !props.isDataFetched || false,
      page: props.page || 1,
      searchText: props.defaultSearchValue || '',
      searchValue: props.defaultSearchValue || '',
      dataUpdated: props.data,
      selectedRowCount: 0,
      hideTableSpinner: false,
      isInitialDataFetchingBlock: props.defaultSorted && props.defaultSorted.length ? true : false
    };
    this.selectedRows = {};
    this.escapeSearchText = this.escapeSearchText.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.updateFilterParams = this.updateFilterParams.bind(this);
    this.updateTableData = this.updateTableData.bind(this);
    this.rowStyle = this.rowStyle.bind(this);
    this.ordering = "-lastmod";
    if (props.defaultSorted && props.defaultSorted.order) {
      this.ordering = props.defaultSorted.order === "desc" ? "-".concat(props.defaultSorted.dataField) : props.defaultSorted.dataField;
    }
    _eventBus.default.dispatch("updatedTableFilters", [{
      key: 'page',
      value: props.page || 1
    }, {
      key: 'page_size',
      value: (props === null || props === void 0 ? void 0 : props.sizePerPageValue) || 15
    }, {
      "key": "ordering",
      "value": this.ordering
    }]);
  }
  componentDidMount() {
    const {
      remote,
      name
    } = this.props;
    if (!remote) {
      _eventBus.default.on("updateTable", updatedData => {
        const {
          dataUpdated
        } = this.state;
        if (updatedData.type === name) this.setState({
          dataUpdated: [...updatedData.data, ...dataUpdated]
        });
      });
    }
  }
  componentDidUpdate(prevProps) {
    const {
      dataUpdated
    } = this.state;
    const {
      data,
      isSelectable
    } = this.props;
    /*
     * To prevent the execution of the block in case of Form component,
     * updated the condition here.
     * TODO: Check if there's a way to prevent its execution.
    */
    if (dataUpdated !== data && !isSelectable) {
      this.setState({
        dataUpdated: data
      });
    }
    if (this.props.isDataFetched !== prevProps.isDataFetched) {
      this.setState({
        isDataFetched: this.props.isDataFetched,
        loading: !this.props.isDataFetched,
        page: 1
      });
    }
  }
  customTotal(from, to, size) {
    const {
      callbackDataSize
    } = this.props;
    callbackDataSize(size);
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "react-bootstrap-table-pagination-total"
    }, size, ' ', "results");
  }
  headerSortingClasses(column, sortOrder) {
    return sortOrder === 'asc' ? 'sorting-asc' : 'sorting-desc';
  }
  escapeSearchText(inputString) {
    const escapeBackSlash = inputString.includes('\\') ? inputString.replace('\\', '\\\\') : inputString;
    const escapeQuote = escapeBackSlash.includes('"') ? escapeBackSlash.replace('"', '\\"') : escapeBackSlash;
    return "\"".concat(escapeQuote, "\"");
  }
  updateFilterParams(states) {
    const {
      columns,
      fetchData,
      sizePerPageValue
    } = this.props;
    this.setState({
      hideTableSpinner: true
    });
    const newState = states;
    const {
      page,
      sizePerPage,
      sortOrder
    } = newState;
    let {
      searchText,
      sortField
    } = newState;
    let searchParams = [{
      key: 'page',
      value: page || 1
    }, {
      key: 'page_size',
      value: sizePerPage || sizePerPageValue
    }];
    if (searchText) {
      searchText = this.escapeSearchText(searchText);
      searchParams = [...searchParams, {
        key: 'search',
        value: searchText
      }];
    }
    if (sortField || sortOrder) {
      columns.map(item => {
        if (sortField === item.dataField && item.sortColumnName) {
          sortField = sortOrder === 'asc' ? item.sortColumnName : item.sortColumnName.replace(/,/g, ',-');
        }
      });
      const sortColumn = sortOrder !== 'desc' ? sortField : "-".concat(sortField);
      searchParams = [...searchParams, {
        key: 'ordering',
        value: sortColumn
      }];
    }
    _eventBus.default.dispatch("updatedTableFilters", searchParams);
    return fetchData(searchParams, false, true);
  }
  updateTableData(response, page) {
    const {
      handleTableChange
    } = this.props;
    const updatedPage = page > response.last ? response.last : page;
    this.setState({
      isDataFetched: true,
      loading: false,
      page: updatedPage
    });
    handleTableChange(response, updatedPage);
  }
  handleTableChange(type, newState) {
    if (!this.state.isInitialDataFetchingBlock) {
      const updatedStates = newState;
      const {
        searchText
      } = this.state;
      if (!(searchText === newState.searchText && !newState.sortField && !newState.page)) {
        if (searchText !== newState.searchText) {
          this.setState({
            searchText: newState.searchText
          });
        }
        this.setState({
          loading: true,
          page: updatedStates.page
        });
        this.updateFilterParams(updatedStates).then(response => {
          // Setting page to 1 when we get no results.
          const pageNo = response.filteredData && !response.filteredData.length ? 1 : updatedStates.page;
          this.updateTableData(response, pageNo);
        }).catch(response => {
          this.updateTableData(response, 1);
        });
      }
    } else {
      this.setState({
        isInitialDataFetchingBlock: false
      });
    }
  }
  rowStyle(row, rowIndex) {
    const {
      evenRowBackgroundColor,
      oddRowBackgroundColor
    } = this.props;
    const style = {};
    if (rowIndex % 2 === 0) {
      style.backgroundColor = evenRowBackgroundColor;
    } else {
      style.backgroundColor = oddRowBackgroundColor;
    }
    return style;
  }
  render() {
    const {
      columns,
      headerBackgroundColor,
      footerBackgroundColor,
      hidePageListOnlyOnePage,
      isPagination,
      isSearch,
      noDataFoundText,
      onTablePageChange,
      onTableSort,
      perPage,
      searchableColumn,
      showTotal,
      sizePerPageValue,
      sortColumn,
      tableLayout,
      totalSize,
      remote,
      isSelectable,
      noSearchFoundText
    } = this.props;
    const {
      isDataFetched,
      loading,
      page,
      searchValue,
      dataUpdated,
      selectedRowCount
    } = this.state;
    columns.map(item => {
      const element = item;
      element.headerStyle = {
        backgroundColor: headerBackgroundColor
      };
      element.footerStyle = {
        backgroundColor: footerBackgroundColor
      };
      return element;
    });
    if (sortColumn && sortColumn.positions) {
      sortColumn.positions.map(element => {
        columns[element].sort = sortColumn.sort;
        columns[element].headerSortingClasses = this.headerSortingClasses;
        columns[element].onSort = (field, order) => {
          onTableSort(field, order);
        };
        return element;
      });
    }
    if (searchableColumn) {
      columns.map(item => {
        const element = item;
        if (!searchableColumn.includes(item.dataField)) {
          element.searchable = false;
        } else element.searchable = true;
        return element;
      });
    }
    const paginationObject = {};
    let options = {
      showTotal,
      hideSizePerPage: !perPage,
      hidePageListOnlyOnePage,
      sizePerPage: sizePerPageValue,
      firstPageText: '«',
      lastPageText: '»',
      alwaysShowAllBtns: true,
      paginationTotalRenderer: this.customTotal.bind(this),
      onPageChange: (page, sizePerPage) => {
        onTablePageChange(page, sizePerPage);
      }
    };
    if (isPagination) {
      options = {
        ...options
      };
      paginationObject.pagination = (0, _reactBootstrapTable2Paginator.default)(options);
    } else if (remote && !remote.sort && !remote.search) {
      options = {
        ...options,
        page,
        sizePerPage: sizePerPageValue,
        totalSize,
        onPageChange: (page, sizePerPage) => {
          onTablePageChange(page, sizePerPage, totalSize);
        }
      };
      paginationObject.pagination = (0, _reactBootstrapTable2Paginator.default)(options);
    }
    const noDataIndication = () => {
      let renderNoData;
      if (!remote && !isDataFetched || remote && isDataFetched) {
        renderNoData = noDataFoundText;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "no-data--wrapper"
      }, noSearchFoundText && dataUpdated.length ? noSearchFoundText : renderNoData);
    };
    let spinnerSize = '7rem';
    let thickness = '.6em solid currentColor';
    if (dataUpdated.length && dataUpdated.length <= 2 || !dataUpdated.length && typeof noDataFoundText === 'string') {
      spinnerSize = '3rem';
      thickness = '.4em solid currentColor';
    }
    let displayOverlay = {};
    if (remote) {
      displayOverlay = {
        loading,
        overlay: (0, _reactBootstrapTable2Overlay.default)({
          spinner: /*#__PURE__*/_react.default.createElement(_Spinner.Spinner, {
            color: "primary",
            diameter: spinnerSize,
            loadingtext: "",
            spinnerposition: "container",
            thickness: thickness
          }),
          styles: {
            overlay: base => ({
              ...base,
              background: 'none'
            })
          }
        })
      };
    }
    if (isSelectable) {
      this.props = {
        ...this.props,
        selectRow: {
          mode: 'checkbox',
          classes: 'selection-row',
          headerColumnStyle: {
            backgroundColor: headerBackgroundColor
          },
          onSelect: (row, isSelect, rowIndex) => {
            const index = this.state.dataUpdated.indexOf(row);
            if (isSelect) {
              this.selectedRows[index] = row;
            } else {
              delete this.selectedRows[index];
            }
            this.setState({
              selectedRowCount: Object.keys(this.selectedRows).length
            });
          },
          onSelectAll: (isSelect, rows) => {
            rows.map((row, rowIndex) => {
              const index = this.state.dataUpdated.indexOf(row);
              if (isSelect) {
                this.selectedRows[index] = row;
              } else {
                delete this.selectedRows[index];
              }
            });
            this.setState({
              selectedRowCount: Object.keys(this.selectedRows).length
            });
          }
        }
      };
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "react-bootstrap-table-wrapper\n        ".concat(tableLayout, "\n        ").concat(isSearch ? 'with--search' : 'no--search', "\n        ").concat(showTotal ? 'with--total' : 'no--total', "\n        ").concat(isPagination ? 'with--pagination' : 'no--pagination')
    }, /*#__PURE__*/_react.default.createElement(_toolkit.Toolkit, (0, _extends2.default)({}, this.props, paginationObject, displayOverlay, {
      rowStyle: this.rowStyle,
      noDataIndication: noDataIndication,
      onTableChange: this.handleTableChange,
      searchValue: searchValue,
      handleRemoveRows: this.handleRemoveRows,
      data: dataUpdated,
      selectedRowCount: selectedRowCount
    })));
  }
}
exports.Table = Table;
Table.defaultProps = {
  headerBackgroundColor: '#ebf0f5',
  footerBackgroundColor: '#ebf0f5',
  evenRowBackgroundColor: '#f8f9fa',
  oddRowBackgroundColor: '#ffffff',
  delay: 250,
  isSearch: false,
  searchableColumn: ['id'],
  sizePerPageValue: 10,
  tableLayout: 'auto',
  showTotal: true,
  perPage: false,
  defaultSearchValue: '',
  remote: false,
  noDataFoundText: 'No search results found',
  hidePageListOnlyOnePage: false,
  onTableSearch: () => {},
  searchBlurHandler: () => {},
  searchInfoText: 'Default serach text',
  onTablePageChange: () => {},
  onTableSort: () => {},
  callbackDataSize: () => {}
};
Table.propTypes = {
  /** Performs actions after onSearch executes. */
  afterOnSearch: _propTypes.default.func,
  /** This callback function will be called only when data size change by search/filter etc. */
  callbackDataSize: _propTypes.default.func,
  /** Accepts a single Array object. */
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    dataField: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired,
    sortColumnName: _propTypes.default.string,
    sortFunc: _propTypes.default.func,
    formatter: _propTypes.default.func
  })),
  /** Custom Prop. Enabled when startsWith type of search is expected. Defaults to false */
  customSearch: _propTypes.default.bool,
  /** Provides data for your table. It accepts a single Array object. */
  data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  /** Specify if table should load with some default search. */
  defaultSearchValue: _propTypes.default.string,
  /** Delays the search call by specified number */
  delay: _propTypes.default.number,
  /** Change background color for even rows. */
  evenRowBackgroundColor: _propTypes.default.string,
  /** Custom Prop.
   *  Applicable when remote is enabled.
   *  Used to fetch the API response on handleTableChange.
   *  Accepts three args viz. searchParams, setCount and setSize.
   *  Default value is false for setCount and setSize. */
  fetchData: _propTypes.default.func,
  /** Callback function. Will be called when remote is enabled.*/
  handleTableChange: _propTypes.default.func,
  /** Change table header background color. */
  headerBackgroundColor: _propTypes.default.string,
  /** Change table footer background color. */
  footerBackgroundColor: _propTypes.default.string,
  /** Hides the pagination when there's only one page in table. */
  hidePageListOnlyOnePage: _propTypes.default.bool,
  /** Set to true when the api response is received. */
  isDataFetched: _propTypes.default.bool,
  /** Enables pagination */
  isPagination: _propTypes.default.bool,
  /** Enable search box. */
  isSearch: _propTypes.default.bool,
  /** Enable row selection. */
  isSelectable: _propTypes.default.bool,
  /** Custom Prop. Manage styles when file uploader is displayed */
  isUploader: _propTypes.default.bool,
  /** Specify which column is unique. */
  keyField: _propTypes.default.string.isRequired,
  /** If current data size is empty, table will call the noDataFoundText prop and get the result to display. */
  noDataFoundText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /** Change background color for odd rows. */
  oddRowBackgroundColor: _propTypes.default.string,
  /** Called when search is triggered. */
  onSearch: _propTypes.default.func,
  /** Call this method when click on pagination. */
  onTablePageChange: _propTypes.default.func,
  /** Call this method with search text when you want to do the search. */
  onTableSearch: _propTypes.default.func,
  /** Call this method on column sort. */
  onTableSort: _propTypes.default.func,
  /** Specify current page number. Resets to 1 when remote search is enabled. */
  page: _propTypes.default.number,
  /** Display perPage dropdown. */
  perPage: _propTypes.default.bool,
  /** Provides functionality to handle all the table change events, like: pagination, insert, filtering etc. through remote server or databse. */
  remote: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
    sort: _propTypes.default.bool,
    search: _propTypes.default.bool,
    pagination: _propTypes.default.bool
  })]),
  /** Call this method when focus is outside search input. */
  searchBlurHandler: _propTypes.default.func,
  /** Specify list of searchable columns. */
  searchableColumn: _propTypes.default.arrayOf(String),
  /** Search info text which will guild users what are the columns that can be searchable */
  searchInfoText: _propTypes.default.string,
  /** Specify number of rows to display on one page. */
  sizePerPageValue: _propTypes.default.number,
  /** Display total number of dataset. */
  showTotal: _propTypes.default.bool,
  /** Mentions the list of column for which sort is required. */
  sortColumn: _propTypes.default.shape({
    positions: _propTypes.default.arrayOf(_propTypes.default.number),
    sort: _propTypes.default.bool
  }),
  /** Specify if table columns should be equally distributed OR should adjust automatically based on column data. */
  tableLayout: _propTypes.default.oneOf(['auto', 'fixed']),
  /** Specifies total number of records. */
  totalSize: _propTypes.default.number
};